import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeButtonCategory} from "./get_amplitude_button_category_by_view";
import {getAmplitudeItemIdProperties, IAmplitudeItemIdParams} from "./get_amplitude_item_id_properties";

interface ITrackAmplitudeButtonClickParams extends Omit<IAmplitudeItemIdParams, "propertyId"> {
    buttonCategory: AmplitudeButtonCategory;
    buttonLink?: string | null;
    buttonName: string;
    externalSource?: string | null;
    isExternal?: boolean;
    location?: string;
    offerSource?: "external" | null;
    /** An explicit `null` reports "no unit behind this click"; leaving it out keeps the key out of the payload. */
    propertyId?: IAmplitudeItemIdParams["propertyId"] | null;
    stepName?: string;
    value?: string | null;
}

export const trackAmplitudeButtonClick = (params: ITrackAmplitudeButtonClickParams) => {
    const {buttonCategory, buttonLink, buttonName, externalSource, isExternal, itemId, location, offerId, offerSource, propertyId, stepName, value} = params;

    const eventProperties: Record<string, string | number | null> = {
        button_category: buttonCategory,
        button_name: buttonName
    };

    if (location != null) eventProperties.location = location;
    if (value !== undefined) eventProperties.value = value;
    if (buttonLink !== undefined) eventProperties.button_link = buttonLink;
    if (stepName != null) eventProperties.step_name = stepName;
    if (offerSource !== undefined) eventProperties.offer_source = offerSource;
    if (externalSource !== undefined) eventProperties.external_source = externalSource;

    if (isExternal) {
        eventProperties.item_id = null;
        eventProperties.property_id = null;
    } else {
        // An explicit null means "no unit behind this click", which DSA-A-58 still wants reported.
        Object.assign(
            eventProperties,
            propertyId === null ? {property_id: null} : {},
            getAmplitudeItemIdProperties({itemId, offerId, propertyId: propertyId ?? undefined})
        );
    }

    trackAmplitudeEvent("button_click", eventProperties);
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeButtonCategory} from "./get_amplitude_button_category_by_view";
import {getAmplitudeItemIdProperties, IAmplitudeItemIdParams} from "./get_amplitude_item_id_properties";

interface ITrackAmplitudeButtonClickParams extends Omit<IAmplitudeItemIdParams, "propertyId"> {
    buttonCategory: AmplitudeButtonCategory;
    buttonLink?: string | null;
    buttonName: string;
    externalSource?: string | null;
    isExternal?: boolean;
    location?: string;
    offerSource?: "external" | null;
    /** An explicit `null` reports "no unit behind this click"; leaving it out keeps the key out of the payload. */
    propertyId?: IAmplitudeItemIdParams["propertyId"] | null;
    stepName?: string;
    value?: string | null;
}

export const trackAmplitudeButtonClick = (params: ITrackAmplitudeButtonClickParams) => {
    const {buttonCategory, buttonLink, buttonName, externalSource, isExternal, itemId, location, offerId, offerSource, propertyId, stepName, value} = params;

    const eventProperties: Record<string, string | number | null> = {
        button_category: buttonCategory,
        button_name: buttonName
    };

    if (location != null) eventProperties.location = location;
    if (value !== undefined) eventProperties.value = value;
    if (buttonLink !== undefined) eventProperties.button_link = buttonLink;
    if (stepName != null) eventProperties.step_name = stepName;
    if (offerSource !== undefined) eventProperties.offer_source = offerSource;
    if (externalSource !== undefined) eventProperties.external_source = externalSource;

    if (isExternal) {
        eventProperties.item_id = null;
        eventProperties.property_id = null;
    } else {
        // An explicit null means "no unit behind this click", which DSA-A-58 still wants reported.
        Object.assign(
            eventProperties,
            propertyId === null ? {property_id: null} : {},
            getAmplitudeItemIdProperties({itemId, offerId, propertyId: propertyId ?? undefined})
        );
    }

    trackAmplitudeEvent("button_click", eventProperties);
};
